import script from "./CustomTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTable.vue?vue&type=script&setup=true&lang=js"

import "./CustomTable.vue?vue&type=style&index=0&id=dcc5a684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcc5a684"]])

export default __exports__